// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zDva","left":"styles_left__Y2pfy"};